module.exports = __webpack_public_path__ + "static/media/send_gift_icon-deep.59088c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/send_gift_icon-deep.png
// module id = 2123
// module chunks = 6